// routes/AppRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import BeneficiariesPage from '../pages/BeneficiariesPage';
import HomeVisits from '../pages/HomeVisits';


import Antenatal from '../pages/Antenatal';
import LoginPage from '../pages/Auth/LoginPage';
import RegisterPage from '../pages/Auth/RegisterPage';

import Referrals from '../pages/Referrals';
import VHNDManagement from '../pages/VHNDManagement';
import ReportsAnalytics from '../pages/ReportsAnalytics';
import HomeVisitAdd from '../pages/HomeVisitAdd';
import ImmunizationAdd from '../pages/ImmunizationAdd';
import ReferralAdd from '../pages/ReferralAdd';
import Immunization from '../pages/Immunization';
import BeneficiaryAdd from '../pages/BeneficiaryAdd';
import FamilyTree from '../pages/FamilyTree';
import VhndCreate from '../pages/VhndCreate';
import ANCVisitForm from '../pages/ANCVisitForm';
import TaskSummary from '../pages/report/TaskSummary';
import AncRegistrationForm from '../pages/AncRegistrationForm';
import HighRiskCases from '../pages/HighRiskCases';
import VHNDParticipation from '../pages/VHNDParticipation';
import VHNDOverview from '../pages/VHNDOverview';
import VHNDUpcoming from '../pages/VHNDUpcoming';
import VHNDEventSummary from '../pages/VHNDEventSummary';
 
const AppRoutes = () => {
  return ( 
    <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
      <Route path="/" element={<Dashboard />} />
      <Route path="/beneficiaries-view" element={<BeneficiariesPage />} />
      <Route path="/home-visits" element={<HomeVisits />} />

      <Route path="/anc" element={<Antenatal />} />
      <Route path="/referrals" element={<Referrals />} />
      <Route path="/vhnd" element={<VHNDManagement />} />
      <Route path="/reports" element={<ReportsAnalytics />} />
      <Route path="/home-add" element={<HomeVisitAdd />} />
      <Route path="/immunization-add" element={<ImmunizationAdd />} />
      <Route path="/referral-add" element={<ReferralAdd />} />
      <Route path="/immunization" element={<Immunization />} />
      <Route path="/beneficiary-add" element={<BeneficiaryAdd />} />
      <Route path="/family-tree/:id" element={<FamilyTree />} />
      <Route path="/VHND-create" element={<VhndCreate />} />
      <Route path="/anc-create" element={<ANCVisitForm />} />
      <Route path="/task-summary" element={<TaskSummary />} />
      <Route path="/anc-register" element={<AncRegistrationForm />} />
       <Route path="/high-risk-cases" element={<HighRiskCases />} />
        <Route path="/vhnd-participation" element={<VHNDParticipation />} />
           <Route path="/vhnd-overview" element={<VHNDOverview />} />
             <Route path="/vhnd-upcoming" element={<VHNDUpcoming />} />
               <Route path="/vhnd-event-summary" element={<VHNDEventSummary />} />
        
      {/* Add more routes as needed */}
    </Routes>
  );      
};  

export default AppRoutes; 
